window.addEventListener('DOMContentLoaded', function(){
    // $(".js-accordion-button").on("click", function () {
    //     $(this).next().slideToggle();
    //     $(this).toggleClass("on");
    // });

    $('.js-q').on('click', function() {//タイトル要素をクリックしたら
        var findElm = $(this).next('.js-a');//直後のアコーディオンを行うエリアを取得し
        $(findElm).stop().slideToggle();//アコーディオンの上下動作
          
        if($(this).hasClass('on')){//タイトル要素にクラス名closeがあれば
          $(this).removeClass('on');//クラス名を除去し
        }else{//それ以外は
          $(this).addClass('on');//クラス名closeを付与
        }
      });

});